import { render, staticRenderFns } from "./stylesTab.vue?vue&type=template&id=4158ae98&"
import script from "./stylesTab.vue?vue&type=script&lang=js&"
export * from "./stylesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports